import React, { useReducer, createContext } from 'react';

const initialState = {
	language: 'es',
	menuStatus: true,
};
function reducer(state, action) {
	return { ...state, ...action };
}

const GlobalsContext = createContext({});

const GlobalsProvider = props => {
	const { children } = props;
	const [state, dispatch] = useReducer(reducer, initialState);
	return (
		<GlobalsContext.Provider
			value={{
				state,
				dispatch,
			}}>
			{children}
		</GlobalsContext.Provider>
	);
};

export { GlobalsContext, GlobalsProvider };
